import type { TableProps } from 'antd';
import { Breadcrumb, Button, Table } from 'antd';
import { FiPlus } from 'react-icons/fi';

import { Layout } from '../../components/layout';
import { TemplateDrawer } from './components';
import type { EmailTemplatesProps, EmailTemplateType } from './EmailTemplates.types.ts';

import './EmailTemplates.styles.css';
import { BREADCRUMBS, EMAIL_TEMPLATES_COLUMNS } from './EmailTemplates.constants.tsx';
import { ConfirmDeleteButton } from '../../components/confirm-delete-button';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '../admin/components';
import { useEffect } from 'react';

export default function EmailTemplates({
  templates,
  isLoading,
  openTemplateDrawer,
  onOpenTemplateDrawer,
  onCloseTemplateDrawer,
  onSubmitTemplate,
  onDeleteTemplates,
  setSelectedTemplateKeys,
  emailTemplateId,
  itemsToDeleteCount,
}: EmailTemplatesProps) {
  const { t } = useTranslation();
  const rowSelection: TableProps<EmailTemplateType>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedTemplateKeys(selectedRowKeys);
    },
  };
  useEffect(() => {
    document.title = `Administration ${t('pages.admin.module.email-templates')}`;
  }, [t]);

  return (
    <Layout>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="admin-page">
          <Breadcrumb className="breadcrumb" items={BREADCRUMBS} />

          <div className="admin-page-bar">
            <h1 className="admin-page-bar--title">{t('pages.admin.module.email-templates')}</h1>
            <div className="admin-page-bar--actions">
              <ConfirmDeleteButton
                onSubmit={onDeleteTemplates}
                disabled={itemsToDeleteCount === 0}
                count={itemsToDeleteCount}
              />
              <Button
                icon={<FiPlus />}
                iconPosition="start"
                size="large"
                type="primary"
                onClick={(event) => onOpenTemplateDrawer(event, null)}
              >
                {t('common.add-new')}
              </Button>
            </div>
          </div>
          <Table<EmailTemplateType>
            rowKey="id"
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            columns={EMAIL_TEMPLATES_COLUMNS}
            dataSource={templates}
            onRow={(record) => {
              return {
                onClick: (event: React.MouseEvent<HTMLButtonElement>) =>
                  onOpenTemplateDrawer(event, record?.id || null),
              };
            }}
          />
          {openTemplateDrawer && (
            <TemplateDrawer
              open={openTemplateDrawer}
              onClose={onCloseTemplateDrawer}
              onSubmit={onSubmitTemplate}
              emailTemplateId={emailTemplateId}
            />
          )}
        </div>
      )}
    </Layout>
  );
}
